module.exports = __webpack_public_path__ + "assets/img/left_active_icon.683d5bdf.png";